import { render } from "./Medication.vue?vue&type=template&id=dae5dd5e"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"

import "./Medication.vue?vue&type=style&index=0&id=dae5dd5e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/Medication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dae5dd5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dae5dd5e', __exports__)) {
    console.log('reload')
    api.reload('dae5dd5e', __exports__)
  }
  
  module.hot.accept("./Medication.vue?vue&type=template&id=dae5dd5e", () => {
    console.log('re-render')
    api.rerender('dae5dd5e', render)
  })

}


export default __exports__